export default __webpack_public_path__ + "alberta-orthopedic-technology.1be761570cb4346f3d5d.svg";